import gql from 'graphql-tag';

export const CompanyHubSpaceQuery = gql`
	query CompanyHubSpaceQuery($key: String!) {
		space(key: $key) {
			id
		}
	}
`;
